// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_a1f56c3","buttonText":"_76b2f07","regulatoryText":"_85bc5b0","checkbox":"_57fdc2c","infoTooltip":"_c39d93d","tooltipContentWrapper":"_5357771"};